import React from "react";

import PropTypes from "prop-types";
import Container from "react-bootstrap/Container";

import CookieBanner from "../consent/cookieBanner";
import Footer from "../footer/footer";
import Header from "../header/header";

const MainLayout = ({ children = null }) => (
  <Container fluid>
    <Header />

    <main>{children}</main>

    <Footer />

    <CookieBanner />
  </Container>
);

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
